export const extractAirportName = (airports: any, id: any) => {
  const name = airports.filter((airport: any) => airport.id === id)[0].name;
  return name.substring(0, name.indexOf(","));
};
